// extracted by mini-css-extract-plugin
export var gitHubAlertLink = "styles-module--gitHubAlertLink--51dce";
export var header = "styles-module--header--648d1";
export var headerContainer = "styles-module--headerContainer--db892";